/* eslint-disable @typescript-eslint/no-empty-function */
import { Component } from '@angular/core';
import { PaymentSaleService } from './payment-sale.service';
@Component({
  selector: 'pg-payment-sale',
  templateUrl: './payment-sale.component.html'
})
export class PaymentSaleComponent {
  selectedPayment = null;
  typesPayment = this.paymentSaleService.typesPayment;
  constructor(private paymentSaleService: PaymentSaleService) {}

  ngOnInit() {
    this.selectedPayment = this.typesPayment[0];
    this.paymentSaleService.setData(this.selectedPayment);
  }

  onSelectPayment(event) {
    this.paymentSaleService.setData(event);
  }
}
